import * as React from "react";
import ILayoutProps from "./ILayout";
import Header from "../Header";
import "../../../assets/sass/components/layout.scss";
import LegacyFooter from "../LegacyFooter";

/**
 * @category Main Component
 * @description this component renders Popup while user trying to navigate aways from the dynamic form , so that user will be aware that the enter values will be lost if the user is navigating away from the form
 */
const Layout: React.FC<ILayoutProps> = (props) => {
    return (
        <div className="layout">
            <Header />
            {props.children}
            <LegacyFooter />
        </div>
    );
};

export default Layout;
